import { render, staticRenderFns } from "./printface.vue?vue&type=template&id=236c7e95&scoped=true&"
import script from "./printface.vue?vue&type=script&lang=js&"
export * from "./printface.vue?vue&type=script&lang=js&"
import style0 from "./printface.vue?vue&type=style&index=0&id=236c7e95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c7e95",
  null
  
)

export default component.exports